import React from 'react';
import PromoSummaryStat from '../components/Promo/PromoSummaryStat/PromoSummaryStat';
import Offer from '../components/Promo/Offer/Offer';
import OffersPage from '../components/Promo/OffersPage/OffersPage';
import OfferStatPage from '../components/Promo/OfferStatPage/OfferStatPage';
import Company from "../components/Company/Company";

const DevRoutes = [
    {
        collapse: false,
        path: "/",
        name: {
            "ru": "Главная",
            "en": "Main",
            "sk": "Hlavná"
        },
        state: "home",
        icon: "mdi mdi-home",
    },
    {
        navlabel: true,
        companyTitle: true,
        name: {
            "ru": "Администрирование",
            "en": "Administration",
            "sk": "Podávanie"
        },
        icon: "mdi mdi-dots-horizontal",
    },
    /*{
        collapse: false,
        path: "/dashboard/apps",
        state: "apps",
        name: {
            "ru":"Приложения",
            "en": "Apps",
            "sk": ""
        },
        mini: "B",
        icon: "mdi mdi-apps",
        component: PromoPage,
    },*/
    {
        collapse: false,
        path: "/dashboard/offerstat",
        state: "offerstat",
        name: {
            "ru":"Статистика",
            "en": "Statistics",
            "sk": "Statistics"
        },
        mini: "B",
        icon: "mdi mdi-apps",
        component: OfferStatPage,
    },
    {
        collapse: false,
        path: "/dashboard/promo",
        state: "promotion",
        name: {
            "ru": "Продвижение",
            "en": "Promotion",
            "sk": "Propagácia"
        },
        mini: "B",
        icon: "mdi mdi-barcode",
        component: OffersPage,
    },
    {
        collapse: false,
        path: "/dashboard/summary",
        state: "promo-summary-stat",
        name: {
            "ru": "Общий отчет",
            "en": "General report",
            "sk": "Všeobecná správa"
        },
        mini: "B",
        icon: "mdi mdi-houzz-box",
        component: PromoSummaryStat
    },
    {
        collapse: false,
        path: "/dashboard/company",
        name: {
            "ru": "Настройки",
            "en": "Settings",
            "sk": "Nastavenie"
        },
        state: "companies",
        mini: "B",
        icon: "mdi mdi-settings",
        component: Company
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/offer",
        state: "offerState",
        component: Offer,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/offer/:offerid",
        state: "offer",
        component: Offer,
    },
    /*{
        invisible: true,
        collapse: false,
        path: "/dashboard/statistics/companies/:companyid",
        state: "company-statistics",
        component: CompanyStat,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/statistics/stores/:storeid",
        state: "point-statistics",
        component: StoreStat,
    },*/
];

export default DevRoutes;



// WEBPACK FOOTER //
// ./src/routes/devRoutes.js